import { useEffect, useState } from 'react'
import { proposalsPortal } from '../../services/ApiService'
import ReactGA from 'react-ga4'

// redux
import { useSelector, useDispatch } from 'react-redux'
import { proposalsActions } from '../../store/proposals'
import { useParams } from 'react-router-dom'
import { isRunningInIframe } from '../../lib/Global'

export const useProposalSearch = (
  showAll,
  search,
  status,
  clientName,
  clientLocation,
  proposalId,
  workorderNumber,
  submittedDate,
  approvedDate,
  approvedBy,
  ascSort,
  descSort,
  companyId,
  perPage,
  page,
  searchEnabled
) => {
  const params = useParams()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [proposals, setProposals] = useState([])
  const [summary, setSummary] = useState([])
  const [chips, setChips] = useState({})
  const [hasMore, setHasMore] = useState(false)
  const proposalsStore = useSelector(state => state.proposals)
  const dispatch = useDispatch()

  if (isRunningInIframe()) {
    companyId = params.id
  }

  useEffect(() => {
    ReactGA.event({
      category: 'search',
      action: 'search_proposals'
    })
  }, [search])

  useEffect(async () => {
    try {
      if (proposalsStore.proposals && proposalsStore.proposals.length > 0) {
        setProposals(proposalsStore.proposals)
        setChips({
          totalCount: proposalsStore.proposals.length
        })
        dispatch(proposalsActions.setProposals([]))
        setSummary(proposalsStore.summary)
        dispatch(proposalsActions.setSummary([]))
      } else {
        if (!searchEnabled) return
        setLoading(true)
        setError(false)
        const result = await proposalsPortal(
          search,
          status,
          clientName,
          clientLocation,
          proposalId,
          workorderNumber,
          submittedDate,
          approvedDate,
          approvedBy,
          ascSort ? ascSort + '' : descSort ? descSort + '_d' : '',
          companyId,
          perPage,
          page
        )
        let count = proposals ? proposals.length : 0
        if (result && result.status) {
          if (page === 1) {
            setProposals(result.content.proposals)
            count = result.content.proposals.length
          } else {
            setProposals([...proposals, ...result.content.proposals])
            count = result.content.proposals.length + proposals.length
          }
          setChips({
            totalCount: result.content.totalCount
          })
        }
        setSummary(result.content.summary)
        setHasMore(count < result.content.totalCount)
        setLoading(false)
      }
    } catch (error) {
      /* eslint-disable no-console */
      console.error(error)
    }
  }, [
    showAll,
    search,
    status,
    clientName,
    clientLocation,
    proposalId,
    workorderNumber,
    submittedDate,
    approvedDate,
    approvedBy,
    ascSort,
    descSort,
    perPage,
    page,
    searchEnabled
  ])
  return { loading, error, proposals, summary, setProposals, chips, hasMore }
}
